import React, { FC, useContext, useEffect, useState } from "react";
import "../LicenseInfo/LicenseInfo.css";
import { AppContext } from "../../../App";
import ArrowDown from "../../../assets/ArrowDownBlue.svg";
import ArrowUp from "../../../assets/ArrowUpBlue.svg";
import CopyButton from "../../../assets/copyButton.svg";
import ContainerWithOverlay from "../../UiLib/ContainerWithOverlay/ContainerWithOverlay";
import RenewLicense from "../RenewLicense/RenewLicense";
import { ILicenseViewVersion } from "../../../common/api_interfaces/license/ILicenseView";
import { LicenseStatus } from "../../../common/enums/licenseStatuses";

interface ILicenseInfo {
    license: ILicenseViewVersion;
    index: number;
}

const licenseStatusNames = new Map([
    [LicenseStatus.installed, "Установлена"],
    [LicenseStatus.active, "Активна"],
    [LicenseStatus.requested, "Запрошена"],
    [LicenseStatus.expired, "Истекла"],
]);

const LicenseInfo: FC<ILicenseInfo> = ({ license, index }) => {
    const [isOpenLicenseBlock, setIsOpenLicenseBlock] = useState<boolean>(false);
    const [dateMin, setDateMin] = useState<string>();
    const [updateLicense, setUpdateLicense] = useState<boolean>(false);
    const [copyData, setCopyData] = useState<string>();
    const { showToast } = useContext(AppContext);
    const licenseName: string = `Лицензия от ${dateMin}`;
    const licenseKey: string | undefined = license.serverId;

    const handleRightClickButton = (e: any) => {
        setIsOpenLicenseBlock(!isOpenLicenseBlock);
    };

    useEffect(() => {
        let minDate = new Date();
        let currentDate = new Date();
        let count = 0;
        license.modules.forEach((module) => {
            if (count === 0) {
                minDate = new Date(module.dateFrom ? module.dateFrom : "");
            }
            currentDate = new Date(module.dateFrom ? module.dateFrom : "");
            if (minDate > currentDate) {
                minDate = currentDate;
            }
        });
        const minDateStr: string = `${minDate.toLocaleString("ru", {
            day: "numeric",
            month: "long",
            year: "numeric",
        })}`;

        // Заполнение информации для кнопки "скопировать данные"
        let _copyData: string = `"licenseName": Лицензия от "${minDateStr}"
                                "serverId": ${license.serverId} 
                                "licenses": [${license.modules.map((module) => {
                                    return `{
                                                "name": ${module.name},
                                                "code": ${module.code},
                                                "count": ${module.count},
                                                "dateFrom": ${module.dateFrom},
                                                "dateTo": ${module.dateTo},
                                                "namedCount": ${module.namedCount},
                                                "concurrentCount": ${module.concurrentCount}
                                            }`;
                                })}]`;
        setDateMin(minDateStr);
        setCopyData(_copyData);
    }, []);

    function _onClick(e: any) {
        const text = licenseKey;
        if (!text) {
            return;
        }
        navigator.clipboard.writeText(text);
        showToast("Скопировано в буфер обмена");
    }
    function onClickCopyData(e: any) {
        const text = copyData;
        if (!text) {
            return;
        }
        navigator.clipboard.writeText(text);
        showToast("Скопировано в буфер обмена");
    }

    function getCurrentDate(dateFrom?: string, dateTo?: string) {
        let _dateFrom = new Date(dateFrom ? dateFrom : "");
        let _dateTo = new Date(dateTo ? dateTo : "");

        const dateFromString = _dateFrom.toLocaleString("ru", { day: "numeric", month: "2-digit", year: "numeric" });
        const dateToString = _dateTo.toLocaleString("ru", { day: "numeric", month: "2-digit", year: "numeric" });
        return `${dateFromString}-${dateToString}`;
    }

    return (
        <div className="license-info-container">
            {updateLicense ? (
                <div>
                    <ContainerWithOverlay onOverlayClick={() => {}} style={{zIndex: 10000}}>
                        <RenewLicense onClose={() => setUpdateLicense(false)} license={license} />
                    </ContainerWithOverlay>
                </div>
            ) : null}
            {isOpenLicenseBlock ? (
                <div className="block-main-big">
                    <div className="block-main-header">
                        <div className="div-info-left bold-text" style={{ fontStyle: "Inter" }}>
                            {licenseName}
                        </div>
                        <div className="block-right">
                            <div className={`text-right status-${license.status}`}>
                                {licenseStatusNames.get(license.status)}
                            </div>
                            <button className="blue-arrow-button" onClick={handleRightClickButton}>
                                <img src={ArrowUp} />
                            </button>
                        </div>
                    </div>
                    <div className="license-general-info">
                        <div className="div-info-left bold-text">Общая информация</div>
                        <div style={{ width: "100%" }}>
                            <div className="div-info-right">
                                <div>Регистрационный ключ</div>
                                <div
                                    className="reg-key-main"
                                    id={`${index.toString()}_2`}
                                    onClick={(e: any) => _onClick(e)}
                                    title="Скопировать регистрационный ключ"
                                >
                                    <div className="reg-key-number">{license.serverId}</div>
                                    <div className="small-copy-div">
                                        <img src={CopyButton} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {license.modules.map((module, index) => {
                        return (
                            <div id={index.toString()} className="license-module-info">
                                <div className="div-info-left bold-text">{module.name}</div>
                                <div style={{ width: "100%" }}>
                                    <div className="div-info-right">
                                        <div>Период действия</div>
                                        <div style={{ textAlign: "right", fontWeight: "bold" }}>
                                            {getCurrentDate(module.dateFrom, module.dateTo)}
                                        </div>
                                    </div>
                                    {module.count ? (
                                        <div className="div-info-right">
                                            <div>{"Количество"}</div>
                                            <div style={{ textAlign: "right", fontWeight: "bold" }}>
                                                {`${module.count} шт.`}
                                            </div>
                                        </div>
                                    ) : null}
                                    {module.namedCount || module.concurrentCount ? (
                                        <div>
                                            {module.namedCount ? (
                                                <div className="div-info-right">
                                                    <div>Вид</div>
                                                    <div style={{ textAlign: "right", fontWeight: "bold" }}>
                                                        {`Именная ${module.namedCount} пользователей`}
                                                    </div>
                                                </div>
                                            ) : null}
                                            {module.concurrentCount ? (
                                                <div className="div-info-right">
                                                    {!module.namedCount ? <div>Вид</div> : <div></div>}
                                                    <div style={{ textAlign: "right", fontWeight: "bold" }}>
                                                        {`Конкурентная ${module.concurrentCount} пользователей`}
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        );
                    })}
                    <div className="license-continue-main">
                        <button
                            className="license-con-copy"
                            id={`${index.toString()}_2`}
                            onClick={(e: any) => onClickCopyData(e)}
                        >
                            <div style={{ paddingRight: "5px" }}>
                                <img src={CopyButton} />
                            </div>
                            <div className="p_14">Скопировать данные</div>
                        </button>
                        {license.status === LicenseStatus.active || license.status === LicenseStatus.expired ? (
                            <button className="license-con-button p_14" onClick={() => setUpdateLicense(true)}>
                                Продлить лицензию
                            </button>
                        ) : null}
                    </div>
                </div>
            ) : (
                <div className="block-main-small">
                    <div className="div-info-left bold-text" style={{ fontSize: "16px" }}>
                        {licenseName}
                    </div>
                    <div className="block-right">
                        <div className={`text-right status-${license.status}`}>
                            {licenseStatusNames.get(license.status)}
                        </div>
                        <button className="blue-arrow-button" onClick={handleRightClickButton}>
                            <img src={ArrowDown} />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LicenseInfo;
